import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CategoriaImgFilterService } from '../../services/categoria-img-filter.service';

@Component({
  selector: 'app-ods-display',
  templateUrl: './ods-display.component.html',
  styleUrls: ['./ods-display.component.scss']
})
export class OdsDisplayComponent {
  @Input() sustainableDevelopmentGoals?: string[];
  @Input() commitmentCode?: string | number;
  @Input() useSharedLinks: boolean = false; // Flag para usar links compartidos

  private odsNames: Record<string, string> = {
    '1': 'ODS 1: Fin de la pobreza',
    '2': 'ODS 2: Hambre cero',
    '3': 'ODS 3: Salud y bienestar',
    '4': 'ODS 4: Educación de calidad',
    '5': 'ODS 5: Igualdad de género',
    '6': 'ODS 6: Agua limpia y saneamiento',
    '7': 'ODS 7: Energía asequible y no contaminante',
    '8': 'ODS 8: Trabajo decente y crecimiento económico',
    '9': 'ODS 9: Industria, innovación e infraestructura',
    '10': 'ODS 10: Reducción de las desigualdades',
    '11': 'ODS 11: Ciudades y comunidades sostenibles',
    '12': 'ODS 12: Producción y consumo responsables',
    '13': 'ODS 13: Acción por el clima',
    '14': 'ODS 14: Vida submarina',
    '15': 'ODS 15: Vida de ecosistemas terrestres',
    '16': 'ODS 16: Paz, justicia e instituciones sólidas',
    '17': 'ODS 17: Alianzas para lograr los objetivos'
  };

  constructor(
    private router: Router,
    private categoriaImgFilterService: CategoriaImgFilterService
  ) {}

  formatOds(goals?: string[]): string[] {
    if (!goals || !goals.length) return [];
    const únicos: string[] = [];
    for (const g of goals) {
      const base = (g ?? '').split('.')[0];
      if (base && !únicos.includes(base)) {
        únicos.push(base);
      }
    }
    return únicos;
  }

  get odsNumbers(): string[] {
    return this.formatOds(this.sustainableDevelopmentGoals);
  }

  get hasOds(): boolean {
    return this.odsNumbers.length > 0;
  }

  getOdsName(odsNumber: string): string {
    return this.odsNames[odsNumber] || `ODS ${odsNumber}`;
  }

  navigateToCommitment(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.commitmentCode) {
      this.router.navigate(['/compromisos', this.commitmentCode, 'detalle']);
    }
  }

  /**
   * Obtiene el link de un ODS por su número
   */
  getOdsLink(odsNumber: string): string {
    if (this.useSharedLinks) {
      return this.categoriaImgFilterService.getOdsLink(odsNumber);
    }
    return '';
  }

  /**
   * Maneja el click en una imagen de ODS
   */
  onOdsClick(event: Event, odsNumber: string): void {
    if (this.useSharedLinks) {
      const link = this.getOdsLink(odsNumber);
      if (link) {
        window.open(link, '_blank', 'noopener,noreferrer');
      }
    } else if (this.commitmentCode) {
      this.navigateToCommitment(event);
    }
  }

  /**
   * Determina si la imagen de ODS debe ser clickeable
   */
  isClickable(odsNumber: string): boolean {
    return this.useSharedLinks || !!this.commitmentCode;
  }
}

